import { render } from "./chatGrupoView.vue?vue&type=template&id=6fa6e00f&scoped=true"
import script from "./chatGrupoView.vue?vue&type=script&lang=js"
export * from "./chatGrupoView.vue?vue&type=script&lang=js"

import "./chatGrupoView.vue?vue&type=style&index=0&id=6fa6e00f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa6e00f"]])

export default __exports__